import React, { useState, useEffect } from 'react';
import { Card, Col, Table, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Modal } from '@rd-web-markets/shared/dist/util';
const ClaimTemplateTasksSelection = _ref => {
  let {
    initialTasks,
    show,
    onHide,
    onSubmit
  } = _ref;
  const [tasks, setTasks] = useState([]);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setTasks(initialTasks);
  }, [initialTasks]);
  const toggleInclude = (e, index) => {
    tasks[index]['included'] = e.target.checked;
    setTasks([...tasks]);
  };
  if (!initialTasks.length > 1) return /*#__PURE__*/React.createElement(React.Fragment, null);
  const tasksBody = () => {
    return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, "Tasks Selection"), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Table, {
      className: "table table-bordered"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Category"), /*#__PURE__*/React.createElement("th", null, "Task Title"), /*#__PURE__*/React.createElement("th", null, "Include Task"))), /*#__PURE__*/React.createElement("tbody", null, tasks.map((task, index) => /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, t(task.category_title)), /*#__PURE__*/React.createElement("td", null, t(task.title)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
      type: "checkbox",
      name: "include",
      checked: task.included,
      value: task.included,
      onChange: e => toggleInclude(e, index)
    }))))))));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: "Tasks Selection",
    show: show,
    renderBody: () => tasksBody(),
    onHide: () => onHide(),
    onSubmit: () => onSubmit(tasks)
  });
};
export default ClaimTemplateTasksSelection;